export default __webpack_public_path__ + "static/media/TataMotorsLogo@2x.6b35fb3b.png";